import React, { Component } from "react";
import { StyleSheet, TextInput, View } from "react-native";
import { connect } from "react-redux";
import Text from "@components/AppText";
import Button from "@components/Button";
import colors from "@constants/color";
import { actions as prodActions } from "@reducers/productReducer";
import { addNewProductRequest } from "@services/api";

import t from "@constants/localization";
import testIds from "@constants/testIds";

const PATH = "screens/Search/AddProductRequest";

class ProductRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productToRequest: "",
    };
  }

  addNewProduct = () => {
    addNewProductRequest(this.state.productToRequest)
      .then(() => {
        this.resetState();
        this.textInputRef.clear();
        this.props.dispatch(prodActions.fetchRequestForProductRequest());

        if (
          this.props.route &&
          this.props.route.params &&
          this.props.route.params.fromScreen === "Requested Items"
        ) {
          this.props.navigation.goBack();
        } else {
          this.props.navigation.navigate("ProfileProductRequests");
        }
      })
      .catch((error) => console.log(error));
  };

  get shouldDisableSubmit() {
    return this.state.productToRequest.length === 0;
  }

  get fromScreenName() {
    const { fromScreen = "" } = this.props.route && this.props.route.params;
    return fromScreen || "";
  }

  resetState = () => {
    this.setState({ productToRequest: "" });
  };

  render() {
    return (
      <View style={styles.mainContainer}>
        <Text fontType="content1" style={styles.staticText}>
          {t(`${PATH}/requestItemMsg`)}
        </Text>
        <View style={styles.inputContainer}>
          <TextInput
            testID={testIds.add_product_request}
            ref={(ref) => (this.textInputRef = ref)}
            value={this.state.productToRequest}
            multiline={true}
            numberOfLines={10}
            selectTextOnFocus
            placeholder={t(`${PATH}/enterProductNameHere`)}
            style={{
              textAlignVertical: "top",
            }}
            onChangeText={(text) => this.setState({ productToRequest: text })}
          />
        </View>
        <View
          style={{
            backgroundColor: "#fff",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            testID={testIds.submit_product_request}
            btnText={t(`${PATH}/submit`)}
            buttonWidth="100%"
            borderRadius={24}
            buttonFontType="content1"
            disabled={this.shouldDisableSubmit}
            onPress={this.addNewProduct}
          />
        </View>
      </View>
    );
  }
}

export default connect(null)(ProductRequest);

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: colors.white,
    paddingHorizontal: 20,
    paddingVertical: 30,
  },
  staticText: {},
  inputContainer: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: colors.silver,
    marginVertical: 20,
    borderRadius: 5,
  },
});
